import { render, staticRenderFns } from "./GroupChartList.vue?vue&type=template&id=352c9039"
import script from "./GroupChartList.vue?vue&type=script&lang=js"
export * from "./GroupChartList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports